<h1>Implementation of John Conway's Game of Life built with Angular and NG-ZORRO</h1>
